import { styled, GetProps, Text as TamaguiText } from 'tamagui'

export const Text = styled(TamaguiText, {
  name: 'Text',
  
  // Base styles
  fontFamily: '$body',
  fontWeight: '400',
  color: '$color',
  
  variants: {
    size: {
      xs: {
        fontSize: 11,
        lineHeight: 15,
      },
      sm: {
        fontSize: 12,
        lineHeight: 17,
      },
      base: {
        fontSize: 14,
        lineHeight: 20,
      },
      lg: {
        fontSize: 16,
        lineHeight: 24,
      },
      xl: {
        fontSize: 18,
        lineHeight: 28,
      },
    },
    variant: {
      default: {
        color: '$color',
      },
      muted: {
        color: '$colorMuted',
      },
      accent: {
        color: '$accent',
      },
      error: {
        color: '$error',
      },
      success: {
        color: '$success',
      },
    },
    weight: {
      normal: { fontWeight: '400' },
      medium: { fontWeight: '500' },
      semibold: { fontWeight: '600' },
      bold: { fontWeight: '700' },
    },
    transform: {
      uppercase: {
        textTransform: 'uppercase',
        letterSpacing: 1,
      },
      none: {},
    },
    font: {
      body: {
        fontFamily: '$body',
      },
      mono: {
        fontFamily: '$mono',
      },
    },
  } as const,
  
  defaultVariants: {
    size: 'base',
    variant: 'default',
    weight: 'normal',
  },
})

export type TextProps = GetProps<typeof Text>
